module.exports = __webpack_public_path__ + "media/images/emblems/Stleonard.blason-9f87028c48425c751ec8c8b5046710c2.png";